import clsx from "clsx";
import { AnchorHTMLAttributes, FunctionComponent } from "react";

import * as styles from "./Item.css";

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  special?: boolean;
};

const Item: FunctionComponent<Props> = ({ className, special, ...props }) => {
  return (
    <li className={clsx(className, styles.container)}>
      <a {...props} className={clsx(styles.link, special && styles.special)}>
        {props.children}
      </a>
    </li>
  );
};

export default Item;
